export default __webpack_public_path__ + "4d567a690404c03c2082e386b5542415.svg";